<template>
    <div>
        <div class="u-d-flex flex-state-buttons p-executive-dashboard__claim-numbers">
            <h2 class="u-margin-top-10 u-r-no-margin">
                Claim Numbers
            </h2>
            <option-filters v-if="!diseaseTypeSelected">
                <li :class="{'m-option-filters--active' : chartType === 'total'}"
                    @click="chartType = 'total'">
                    By Type
                </li>
                <li :class="{'m-option-filters--active' : chartType === 'caseNumbersTrendChartData'}"
                    @click="chartType = 'trend'">
                    Trends by Numbers
                </li>
            </option-filters>
        </div>
        <summary-charts v-if="chartType === 'total' && !diseaseTypeSelected"
                        type="number"
                        run-type="averageReserve"
                        :chart-data="caseNumbersChartData">
        </summary-charts>
        <trends-chart v-if="chartType === 'trend' || diseaseTypeSelected"
                      type="number"
                      showing="total"
                      :chart-data="caseNumbersTrendChartData">
        </trends-chart>
    </div>
    
</template>

<script>
    import OptionFilters from 'components/OptionFilters';
    import SummaryCharts from "./charts/SummaryCharts";
    import {mapGetters} from 'vuex';
    import TrendsChart from "./charts/TrendsChart";

    export default {
        name: "numbers-section",
        components: {
            TrendsChart,
            SummaryCharts,
            OptionFilters
        },
        data: () => ({chartType: 'total'}),
        computed: mapGetters('dashboards', [
            'caseNumbersChartData',
            'caseNumbersTrendChartData',
            'diseaseTypeSelected'
        ])
    }
</script>


// WEBPACK FOOTER //
// NumbersSection.vue?5e93bcb0